import { useIsMinTabletSize } from "~/common/hooks/useMediaQuery";
import { type CartElement } from "~/pages/B2CRequestPage";
import B2CRequestCartItem from "./B2CRequestCartItem";
import classes from "./B2CRequestCartList.module.less";
import { t } from "i18next";

interface B2CRequestCartListProps {
  items: CartElement[];
  className?: string;
}

const B2CRequestCartList = ({ items, className }: B2CRequestCartListProps) => {
  const isTablet = useIsMinTabletSize();
  return (
    <div className={classes.root}>
      {isTablet && (
        <div className={classes.header}>
          <div className={classes.product}>
            <b>{t("cartPage.table.header.product.title")}</b>
          </div>
          <div className={classes.quantity}>
            <b>{t("cartPage.table.header.quantity.title")}</b>
          </div>
          <div className={classes.comment}>
            <b>{t("cartPage.report.comment")}</b>
          </div>
        </div>
      )}

      {items.map((item) => (
        <B2CRequestCartItem className={classes.item} item={item} />
      ))}
    </div>
  );
};

export default B2CRequestCartList;
